// Time.js
import React from "react";
import { Field, ErrorMessage } from "formik";
import styles from "./Time.module.scss";
import ErrorText from "components/shared/errortext/ErrorText";
import { combineClasses } from "utils/utils";

const Time = (props) => {
  const { label, name, placeholder, isRequired, inputClassName, ...rest } =
    props;
  return (
    <div className={styles.inputControl}>
      <label className={styles.label} htmlFor={name}>
        {label}{" "}
        {isRequired ? <span className={styles.requiredMark}>*</span> : ""}
      </label>
      <Field name={name}>
        {({ field }) => (
          <input
            {...field}
            {...rest}
            id={name}
            type="time" // Specify the time input type
            className={combineClasses(styles.inputField, inputClassName)}
            placeholder={placeholder}
          />
        )}
      </Field>
      <ErrorMessage name={name} component={ErrorText} />
    </div>
  );
};

export default Time;
